"use client";

import { useLocale } from "next-intl";
import Link from "next/link";

function Icon({ name, className = "", fill = false }: { name: string; className?: string; fill?: boolean }) {
  return <span className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}>{name}</span>;
}

const CATEGORIES = [
  { icon: "calendar_month", ar: "الحجوزات", en: "Bookings", dAr: "إدارة حجوزاتك، التواريخ والتعديلات.", dEn: "Manage your bookings, dates and edits.", href: "explore" },
  { icon: "credit_card", ar: "المدفوعات والاسترداد", en: "Payments & refunds", dAr: "طرق الدفع المدعومة واسترداد المبالغ.", dEn: "Supported payments and refunds.", href: "help" },
  { icon: "shield", ar: "الحساب والأمان", en: "Account & security", dAr: "تأمين حسابك وحماية بياناتك.", dEn: "Secure your account and data.", href: "help" },
  { icon: "hiking", ar: "التجارب والخدمات", en: "Experiences & services", dAr: "استكشف الأنشطة واحجز الخدمات.", dEn: "Explore activities and book services.", href: "destinations" },
  { icon: "gavel", ar: "السلامة والسياسات", en: "Safety & policies", dAr: "معلومات حول الأمان والشروط والخصوصية.", dEn: "Safety, terms and privacy info.", href: "help" },
  { icon: "storefront", ar: "المضيفون والإدراج", en: "Hosts & listing", dAr: "كيف تصبح مضيفاً وتدرج عرضك.", dEn: "Become a host and list your offer.", href: "help" },
];

export default function HelpCategories({ isAr, query }: { isAr: boolean; query: string }) {
  const locale = useLocale();
  const t = (a: string, e: string) => (isAr ? a : e);
  const q = query.trim().toLowerCase();
  const items = CATEGORIES.filter(
    (it) => !q || it.ar.includes(q) || it.en.toLowerCase().includes(q) || it.dAr.includes(q) || it.dEn.toLowerCase().includes(q),
  );

  return (
    <section className="container mx-auto px-6 py-14">
      <h2 className="font-display text-2xl font-bold text-ink-900 mb-8 text-center">
        {t("تصفّح حسب الفئة", "Browse by category")}
      </h2>
      {items.length === 0 ? (
        <p className="text-center text-ink-500">{t("لا توجد فئات مطابقة", "No matching categories")}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it) => (
            <Link
              key={it.ar}
              href={`/${locale}/${it.href}`}
              className="group relative rounded-2xl border border-clay-100 bg-surface p-6 hover:shadow-md hover:border-clay-300 transition-all"
            >
              <span className="absolute top-5 inset-e-5 text-clay-600/70 group-hover:text-clay-600 transition-colors">
                <Icon name={it.icon} className="text-2xl" />
              </span>
              <p className="font-bold text-ink-900 mb-2 pe-9">{t(it.ar, it.en)}</p>
              <p className="text-sm text-ink-500 leading-relaxed">{t(it.dAr, it.dEn)}</p>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
